import React from "react";

const config = require("../../../config.json")
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY
const compagnyColorSecondary = config.APP_COMPAGNYCOLORSECONDARY;

const AdressTitle = {
  display: "block",
  textDecoration: "none",
  color: compagnyColorSecondary,
  fontSize: "11px",
  lineHeight: "normal",
  margin: "0px 0px 3px",
};
const Adress = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  fontSize: "11px",
  maxWidth: "125px",
  margin: "0px 0px 0px",
  lineHeight: "normal"
};
const AdressText = {
  lineHeight: "normal",
  margin: "0px"
}



export default function PostalAdress({title, adressStreet, adressCity}) {
  return (
      <tbody>
        <tr>
          <td>
            <span style={AdressTitle}>{title}</span><br />
            <span style={Adress}>
              <p style={AdressText}>{adressStreet}</p>
              <p style={AdressText}>{adressCity}</p>
            </span>
          </td>
        </tr>
      </tbody>
  );
}
